import { PERSISTED_SESSION, persistItem } from "components";
import { typedQueryClient, useTypedQuery } from "hooks";
import { LANDING_PAGES } from "models";
import { LoginKeys } from "modules/Login/queryKeys";

import type { Session } from "modules/Login/queryKeys";

export const usePermanentSession = () => ({
  session: useTypedQuery({
    queryKey: LoginKeys.session,
    queryFn: () => ({ token: "", zoho_unameit_asap_jwt: "", was_logged_in: false, expire_at: "", logged_in: false, landing_page_id: LANDING_PAGES.Main }),
    enabled: false
  }).data
});

export const setPermanentSession = (session: Session) => {
  typedQueryClient.setQueryData(LoginKeys.session, session);
  persistItem(PERSISTED_SESSION, encodeURIComponent(JSON.stringify(session)), session.expire_at);
};
